// Class for overlay/loading screen
import * as THREE from "three"
import gsap from "gsap"
import Experience from "../Experience"

export default class Overlay{
    constructor(){
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        //console.log("Overlay Class")
        this.getLoadingContainer()
        this.getInstructionsDiv()
        this.setGeometry()
        this.setMaterials()
        this.setMesh()
        this.fadeOverlay()
    }

    getLoadingContainer(){
        this.loadingContainer = document.querySelector(".loadingContainer")
    }

    getInstructionsDiv(){
        this.instructionsDiv = document.getElementById("instructions")
    }

    setGeometry(){
        this.geometry = new THREE.PlaneGeometry(2,2,1,1)
    }
    
    setMaterials(){
        this.material = new THREE.ShaderMaterial({
            transparent: true,
            uniforms:{
                uAlpha: {value: 1}
            },
            vertexShader:`
                void main(){
                    gl_Position = vec4(position, 1.0);
                }
            `,
            fragmentShader:`
                uniform float uAlpha;
                void main(){
                    gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
                }
            `
        })
    }

    setMesh(){
        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )
        this.scene.add(this.mesh)
    }

    fadeOverlay(){
        this.loadingContainer.style.opacity = 0
        //this.loadingContainer.style.zIndex = -1

        gsap.to(this.material.uniforms.uAlpha,{
            duration: 5,
            value: 0,
            onComplete: ()=>{
                //deal with instructions
                //instructions.style.visibility = "visible"
                this.instructionsDiv.style.visibility = "visible"
                gsap.fromTo(this.instructionsDiv,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        duration: 1,
                        onComplete: () => {
                            gsap.to(this.instructionsDiv, {
                                delay: 4,
                                duration: 1,
                                opacity: 0,
                                onComplete: () => {
                                    this.instructionsDiv.style.visibility = "hidden"
                                }
                            })
                        }
                    }
                )
                //console.log('gsap finished in overlay .js')
                //this.loadingContainer.style.opacity = 0
                this.loadingContainer.style.zIndex = -1
            }
        })
    }
}